export enum SortKey {
  PROJECTS_AZ = 'projects_az',
  PROJECTS_ZA = 'projects_za',
  UPDATED_AT_AZ = 'updated_at_az',
  ACTORS_AZ = 'actors_az',
  ACTORS_ZA = 'actors_za',
}
